import { isProd } from '@anm/shared/mode';

const pauseRemoteConsumers = false;

const audioRecordingEnabled = false; // disable because EFS is disabled

// local recording in studio
const localRecordingEnabled = !isProd;

const hot_rejoin = !isProd;

const isTwoOptionsPopupEnabled = true;

// show chooser how to record: via studio or locally
const videoRecorderChooser = !isProd;

const webinarEnabled = !isProd;

export const Features = {
  pauseRemoteConsumers,
  audioRecordingEnabled,
  localRecordingEnabled,
  hot_rejoin,
  webinarEnabled,
  isTwoOptionsPopupEnabled,
  videoRecorderChooser
};
